import { useMutation } from 'react-query';
import { downloadRegisterResultPdfFile } from 'apis/registerResult';

const useDownloadRegisterResultPdfFile = () => useMutation(downloadRegisterResultPdfFile);

export default useDownloadRegisterResultPdfFile;
